import { render, staticRenderFns } from "./sd4_25.vue?vue&type=template&id=08c12765&scoped=true"
import script from "./sd4_25.vue?vue&type=script&lang=js"
export * from "./sd4_25.vue?vue&type=script&lang=js"
import style0 from "./sd4_25.vue?vue&type=style&index=0&id=08c12765&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c12765",
  null
  
)

export default component.exports